import { Button, Dialog, DialogTitle, Grid } from '@material-ui/core'
import React from 'react'
import { DocumentacionLiquidaciones } from './DocumentacionLiquidaciones';

export const ModalDocumentacionLiq = (props) => {
    const { open, closeModalHandler, comprobanteSeleccionado, disabled } = props;

    const closeModal = () => {
        closeModalHandler();
    }

    return (
        <Dialog
            fullWidth
            open={open}
            maxWidth={'md'}
            onClose={closeModal}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <Grid style={{ overflowX: "auto", marginTop: '1rem', padding: '0.5rem' }}>
                <DialogTitle>Documentación</DialogTitle>
                <DocumentacionLiquidaciones comprobanteSeleccionado={comprobanteSeleccionado} disabled={disabled}/>
            </Grid>
            <Grid style={{ margin: '1rem' }}>
                <Button
                    variant="contained"
                    onClick={closeModal}
                    color='primary'
                    style={{ textAlign: 'center', display: 'flex', margin: 'auto' }}
                >
                    Cerrar
                </Button>
            </Grid>
        </Dialog>
    )
}
